import { useEffect, useState } from "react";
import { getHealth, type HealthResponse } from "../api/client.js";
import { StatusPip } from "../components/StatusPip.js";

const FOOTER_LINKS = [
  { label: "System Status", href: "#" },
  { label: "Documentation", href: "#" },
  { label: "API Reference", href: "/api/v1/health" },
  { label: "Privacy", href: "#" },
];

export function Footer() {
  const [health, setHealth] = useState<HealthResponse | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let active = true;
    const tick = async () => {
      try {
        const h = await getHealth();
        if (active) {
          setHealth(h);
          setError(false);
        }
      } catch {
        if (active) setError(true);
      }
    };
    tick();
    const id = window.setInterval(tick, 30_000);
    return () => {
      active = false;
      window.clearInterval(id);
    };
  }, []);

  const tone = error ? "error" : health?.status === "ok" ? "ok" : "warn";
  const status = error ? "HUB UNREACHABLE" : health ? `STATUS ${health.status.toUpperCase()}` : "PROBING…";

  return (
    <footer className="bg-surface-container-lowest w-full py-6 mt-auto border-t border-outline-variant/40 flex flex-col md:flex-row justify-between items-center px-8 gap-4 font-mono text-[10px] uppercase tracking-widest">
      <div className="text-on-surface-variant">© {new Date().getFullYear()} AppsDoCalSync · AppsDo IT</div>
      <div className="flex gap-6">
        {FOOTER_LINKS.map((l) => (
          <a
            key={l.label}
            href={l.href}
            className="text-on-surface-variant hover:text-primary-fixed-dim transition-colors opacity-80 hover:opacity-100"
          >
            {l.label}
          </a>
        ))}
      </div>
      <div className="flex items-center gap-2 text-primary-fixed-dim">
        <StatusPip tone={tone} pulse={!error} />
        <span>{status}</span>
      </div>
    </footer>
  );
}
